// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Iv6h","rootSuccess":"CompleteLink_rootSuccess__GOcd0","rootFailure":"CompleteLink_rootFailure__1ecF_","isDisabled":"CompleteLink_isDisabled__hzPcM"};